const TableSortOption = Object.freeze({
  // Trending
  ALPHABET_ASC: 'ALPHABET_ASC',
  ALPHABET_DSC: 'ALPHABET_DSC',
  PERCENT_ASC: 'PERCENT_ASC',
  PERCENT_DSC: 'PERCENT_DSC',
  LAST_ASC: 'LAST_ASC',
  LAST_DSC: 'LAST_DSC',

  // Index, Demographic
  VALUE_ASC: 'VALUE_ASC',
  VALUE_DSC: 'VALUE_DSC',
  INDEX_ASC: 'INDEX_ASC',
  INDEX_DSC: 'INDEX_DSC',

  ASCEND: 'ASCEND',
  DESCEND: 'DESCEND',
  NONE: 'NONE'
})
export default TableSortOption
export type TableSortOptionStrings = typeof TableSortOption[keyof typeof TableSortOption]
// RESERVE BELOW
